var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29193 13.3333C0.936646 13.3333 0.632505 13.2028 0.379503 12.9417C0.126501 12.6806 0 12.3667 0 12V2.66667C0 2.3 0.126501 1.98611 0.379503 1.725C0.632505 1.46389 0.936646 1.33333 1.29193 1.33333H1.93789V0H3.22981V1.33333H8.39752V0H9.68944V1.33333H10.3354C10.6907 1.33333 10.9948 1.46389 11.2478 1.725C11.5008 1.98611 11.6273 2.3 11.6273 2.66667V6.66667H10.3354V5.33333H1.29193V12H5.81366V13.3333H1.29193ZM12.354 10L10.9814 8.58333L11.4497 8.1C11.5681 7.97778 11.7188 7.91667 11.9019 7.91667C12.0849 7.91667 12.2356 7.97778 12.354 8.1L12.8224 8.58333C12.9408 8.70556 13 8.86111 13 9.05C13 9.23889 12.9408 9.39444 12.8224 9.51667L12.354 10ZM7.10559 14V12.5833L10.5292 9.05L11.9019 10.4667L8.47826 14H7.10559ZM1.29193 4H10.3354V2.66667H1.29193V4Z",
    fill: "#237FB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.ea58f038b1b63a0adf5b99ac8c306773.svg";
export { ForwardRef as ReactComponent };